import React from "react";
import "./ReportTable.css";

const ReportTable = ({ reports }: { reports: any[] }) => {
  // If there's no data, display a message
  if (!reports || reports.length === 0) {
    return <p>No reports to display.</p>;
  }

  // Build the set of all keys present in any row so columns include agent fields
  const columnsSet = new Set<string>();
  reports.forEach(r => {
    if (r && typeof r === 'object') Object.keys(r).forEach(k => columnsSet.add(k));
  });
  const columns = Array.from(columnsSet);

  return (
    <div className="table-container">
      <table>
        <thead>
          <tr>
            {columns.map((col, index) => {
              const rawHeader = String(col)
                .replace(/([a-z0-9])([A-Z])/g, '$1 $2') // split camelCase
                .replace(/_/g, ' ');
              const header = rawHeader
                .split(' ')
                .map(w => {
                  const lower = w.toLowerCase();
                  return lower.charAt(0).toUpperCase() + lower.slice(1);
                })
                .join(' ');
              return <th key={index}>{header}</th>;
            })}
          </tr>
        </thead>
        <tbody>
          {reports.map((report, index) => (
            <tr key={index}>
              {columns.map((col, idx) => (
                <td key={idx}>{report[col] ?? ''}</td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default ReportTable;



